import React, { useState } from "react";
import Adminnav from "../Adminnav";
import axios from "axios";
import toastify from "../../Util/toastify";
import BaseURL from "../../Util/BaseURL";
const AddHub = () => {
  const [address, setAddress] = useState();
  const [district, setDistrict] = useState();
  const [state, setState] = useState();
  const [email, setEmail] = useState();
  const [number, setNumber] = useState();
  const [name, setName] = useState();
  const [pincode, setPincode] = useState();
  const [hubid, setHubId] = useState();
  const [hubPassword, setHubPassword] = useState();

  async function addHub() {
    axios.post(
      `${BaseURL}AddHub`,
      {
        name,
        district,
        state,
        phnumber: number.toString(),
        email,
        pincode,
        address,
      },
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    axios.post(
      `${BaseURL}registerNewDistributionHub`,
      {
        email,
        name: name,
        userName: hubid,
        userPassword: hubPassword,
      },
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    toastify("Distribution Hub Added Successfully", "success");
  }
  return (
    <>
      <Adminnav />
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo row">
            <h1 className="font-weight-bold col">Add Distribution Hub</h1>
          </div>
        </div>
      </section>
      <div className="form-container" style={{ paddingBottom: "20px" }}>
        <form action="" className="checkout-form">
          <div className="input-line">
            <label htmlFor="Name">Name</label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Enter the Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="Address">Address</label>
            <input
              type="text"
              name="address"
              id="address"
              placeholder="Enter the Address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="District">District</label>
            <input
              type="text"
              name="district"
              id="district"
              placeholder="Enter the District"
              value={district}
              onChange={(e) => setDistrict(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="state">State</label>
            <input
              type="text"
              name="state"
              id="state"
              placeholder="Enter the State"
              value={state}
              onChange={(e) => setState(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="pincode">Pincode</label>
            <input
              type="number"
              name="pincode"
              id="pincode"
              placeholder="Enter the Pincode"
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              name="email"
              id="email"
              placeholder="Enter the Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="phone">Phone</label>
            <input
              type="number"
              name="number"
              id="number"
              placeholder="Enter the Number"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
            />
          </div>
          <div className="input-container">
            <div className="input-line">
              <label htmlFor="userName">Username</label>
              <input
                type="text"
                name="userName"
                id="userName"
                placeholder="User Name for the Hub"
                value={hubid}
                onChange={(e) => setHubId(e.target.value)}
              />
            </div>
            <div className="input-line">
              <label htmlFor="password">Password</label>
              <input
                type="text"
                name="password"
                id="password"
                placeholder="Password for the Hub"
                value={hubPassword}
                onChange={(e) => setHubPassword(e.target.value)}
              />
            </div>
          </div>
        </form>
        <button
          type="button"
          className="btn btn-success addcoupon"
          onClick={() => addHub()}
        >
          Add Hub
        </button>
      </div>
    </>
  );
};

export default AddHub;
